import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SellerShellPfComponent } from './seller-shell-pf/seller-shell-pf.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SellerStepOnePfComponent } from './seller-step-one-pf/seller-step-one-pf.component';
import { SellerStepThreePfComponent } from './seller-step-three-pf/seller-step-three-pf.component';
import { SellerResumePfComponent } from './seller-resume-pf/seller-resume-pf.component';
import { SellerStepTwoPfComponent } from './seller-step-two-pf/seller-step-two-pf.component';

const baseModules = [CommonModule, FormsModule, ReactiveFormsModule, SharedModule];

@NgModule({
  declarations: [
    SellerShellPfComponent,
    SellerStepOnePfComponent,
    SellerStepTwoPfComponent,
    SellerResumePfComponent,
    SellerStepThreePfComponent,
  ],
  imports: [baseModules],
})
export class SellerPfModule {}
